import { EventEmitter, Input, OnInit, Output, Directive, DoCheck } from '@angular/core';
import { UniqueSelectionDispatcher } from '@angular/cdk/collections';
import * as uniqid from 'uniqid';
import { SharedDataService } from '../../../../@core/service/shared-data.service';
// import { NbPopoverDirective } from '@nebular/theme';
import { CompilationModel } from '../../../../@models/erp/compilation';
import { AbstractItemType } from '../../abstractItem';

export enum SelectorDisplayMode {
  button = 1,
  input = 2,
  window = 3
}

type columnId = string;

@Directive()
export abstract class DocumentSelectComponent implements OnInit, DoCheck {

  @Input() abstractItem: AbstractItemType;
  @Input() title: string = '';
  @Input() mode: SelectorDisplayMode = SelectorDisplayMode.button;
  @Input() icon: string;
  @Input() iconText: string = '+';
  @Input() latestVersionItems: AbstractItemType[];
  @Input() buttonText: string;
  @Input() style: any;
  @Input() filters: { id: columnId, search: string }[]; // { id: column id, search: string }
  @Input() multiselect = false;
  @Input() selectedItems = new Set<CompilationModel>();


  @Output() buttonClick = new EventEmitter<boolean>();
  @Output() compilationChange = new EventEmitter<CompilationModel | CompilationModel[] | any>();
  
  @Input() businessId: string

  showBusinessInput = false;
  showPagination = true;
  showDisabled = false;
  
  // @ViewChild(NbPopoverDirective, { static: false }) popover: NbPopoverDirective;

  // columns = [
  //   { id: 'type', title: 'Document type', search: '' },
  //   { id: 'code', title: 'Document number', search: '' },
  //   { id: 'recipient', title: 'Recipient', search: '' },
  // ]

  initialItems: AbstractItemType[] = []

  dlgMode = SelectorDisplayMode;

  columns: { id: columnId, title: string, search: string, type?: string }[] = [];

  // TODO: getText -> table (performance)
  abstract getText(col: string, item: AbstractItemType);

  sort = { col: null, dir: -1 }

  filtered = [];

  popup: boolean = false;

  docPage = 1;

  paginationId = 'documentSelectPagination' + uniqid();

  constructor(public data: SharedDataService) { 
  }

  // getText(col: string, item: CompilationModel) {
  //   if (!item) return '';
  //   switch (col) {
  //     case 'type': return CompilationTypeData.get(item.type).name;
  //     case 'code': return item.nameOverride ? item.nameOverride : item.code;
  //     case 'recipient': return (item.recipient || {})['name'];
  //   }
  // }

  ngOnInit() {
    this.initialItems = this.preFilter(this.latestVersionItems);
    this.latestVersionItems = [...this.initialItems];
    // console.log('selector base init', this.latestVersionItems, this.initialItems);
    this.onFilter();
  }

  prevPopupStatus = false;
  ngDoCheck(): void {
    if (this.popup !== this.prevPopupStatus) {
      if (this.popup) this.ngOnInit();
      // this.selectedItems = new Set<CompilationModel>();
      this.setFilters();
      this.onFilter();
      this.prevPopupStatus = this.popup;
    }
  }

  setFilters() {
    this.filters?.forEach(f => {
      this.columns.find(c => c.id === f.id).search = f.search;
    })
  }

  preFilter(items: AbstractItemType[]): AbstractItemType[] {
    return items.filter(f => !f.draft)
  }

  onSort(col) {
    this.sort.col = col.id;
    this.sort.dir = -this.sort.dir;
    this.onFilter()
  }

  onFilter() {
    // let ret = this.preFilter(this.initialItems);
    // console.log('selector onFilter', this.latestVersionItems);
    this.docPage = 1;
    let ret = this.latestVersionItems;
    this.columns.forEach(col => {
      if (col.search && col.search.length) ret = ret.filter(doc => {
        const txt = this.getText(col.id, doc);
        if (txt && col && col.search) return txt.toLocaleLowerCase().includes(col.search.toLocaleLowerCase())
        return '';
      });
    });

    this.filtered = (this.sort.col && ret.sort((a, b) => {
      const numeric = this.columns.find(f => f.id === this.sort.col)?.type === 'number';
      let texta = this.getText(this.sort.col, a);
      let textb = this.getText(this.sort.col, b);
      if (numeric) {
        texta = texta ?? 0;
        textb = textb ?? 0;
        if (+texta === +textb) return 0;
        return +texta > +textb ? this.sort.dir : -this.sort.dir
      } else {
        texta = texta ?? '';
        textb = textb ?? '';
        if (texta === textb) return 0
        return (''+texta).localeCompare(''+textb) > 0 ? this.sort.dir : -this.sort.dir
      }
    })) || ret;
  }

  onSelect(item: CompilationModel, event = null) {
    if (this.multiselect) {
      if (event.ctrlKey) {
        this.selectedItems.has(item) ? this.selectedItems.delete(item) : this.selectedItems.add(item);
      } else {
        this.hide();
        this.compilationChange.emit([item]);
        this.selectedItems = new Set<CompilationModel>();
      }
    } else {
      this.hide();
      this.compilationChange.emit(item);
    }
  }

  clearFilter() {
    this.columns.forEach(col => col.search = '');
    this.selectedItems = new Set<CompilationModel>();
    this.onFilter();
  }

  selectAll() {
    this.selectedItems = new Set(this.filtered);
  }

  hide() {
    // this.popover.hide();
    this.popup = false;
  }

  ok() {
    this.hide();
    this.compilationChange.emit(Array.from(this.selectedItems));
  }

  onButton(hide: boolean = true) {
    this.buttonClick.emit();
    if (hide) this.hide();
  }

  getStyle(item) {
    return this.selectedItems.has(item) ? { 'background-color': '#fb1'} : null;
  }

  onBusinessIdChanged(businessId: string) {} // overridden in document-finished-product-selector
}
